import AsyncLoadingComponent from './async-loading-component.vue'
import AsyncErrorComponent from './async-error-component.vue';

export default function asyncComponent(component) {
  const AsyncHandler = () => ({
    component: component,
    loading: AsyncLoadingComponent,
    error: AsyncErrorComponent,
    delay: 200,
    timeout: 15000
  });
  return Promise.resolve({
    functional: true,
    render(h, {
      data,
      children
    }) {
      return h(AsyncHandler, data, children);
    }
  });
}